// src/components/Downloads.js

import React, { useState, useEffect } from 'react';
import './Downloads.css'; // Create and import a CSS file for styling

function Downloads() {
    // Static data instead of fetching
    const downloadFiles = [
        {
            name: "Jurkat Graph Connectivity",
            description: "Graph connectivity scores and functional annotations for Jurkat cells",
            url: "https://drive.google.com/file/d/1ZjMy4lcwiHpMjmV7tm69FZi-t0pvBZQw/view?usp=sharing"
        },
        {
            name: "Jurkat Fold Change Matrix",
            description: "Matrix containing fold change values for protein interactions",
            url: "https://drive.google.com/file/d/1dLsqUtR7tbQDBqUdQAoKKXVvQmOW8iQ6/view?usp=sharing"
        },
        {
            name: "Jurkat Annotation File",
            description: "Protein annotations and functional classifications",
            url: "https://drive.google.com/file/d/16-4PigtNUH9M8Kcx_vjltqlCA5ToEQSk/view?usp=sharing"
        },
        {
            name: "Daudi Graph Connectivity",
            description: "Graph connectivity scores for Daudi cells",
            url: "https://drive.google.com/file/d/1in-vNpZ57Alx33KePLPCw15C4PvHvyTs/view?usp=sharing"
        },
        {
            name: "Daudi Fold Change Matrix",
            description: "Matrix containing fold change values for protein interactions",
            url: "https://drive.google.com/file/d/1tI5CaYRL_jmmTQqo2LKDK3-phrehBZUx/view?usp=sharing"
        },
        {
            name: "Daudi Annotation File",
            description: "Protein annotations and functional classifications",
            url: "https://drive.google.com/file/d/11x7OpG2vX_zOjwFjCRz9XGPU9PYk-fFO/view?usp=sharing"
        }
    ];

    return (
        <div className="downloads-page">
            <h1>Download</h1>
            <p>To download all data for a given cell line, use the download links below. 
               The data includes network files, fold change matrices, and protein annotations.</p>

            {/* Download Table */}
            <table className="downloads-table">
                <thead>
                    <tr>
                        <th>File Name</th>
                        <th>Description</th>
                        <th>Download</th>
                    </tr>
                </thead>
                <tbody>
                    {downloadFiles.map((file, index) => (
                        <tr key={index}>
                            <td>{file.name}</td>
                            <td>{file.description}</td>
                            <td>
                                <a 
                                    href={file.url} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="download-link"
                                >
                                    Download
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Attribution Section */}
            <div className="attribution">
                <h6><i>For Attribution</i></h6>
                <p>If you use this resource, please cite the following paper:</p>
                <p>Floyd, Brendan <i>et al.</i> Mapping the Nanoscale Organization of the Human Cell Surface Proteome Reveals New Functional Associations and Surface Antigen Clusters. <i>bioRxiv (2025).</i></p>
            </div>
        </div>
    );
}

export default Downloads;